/**
 * Leaderboard filtering + pagination helpers.
 */

import { calculateSeasonStandings } from "./playerRankings";
import { assignOrganizationRanks } from "./organizationRankings";
import { CURRENT_SEASON_KEY, listSeasonOptions } from "./rankingTypes";
import { paginateItems } from "../player/playerCareer";

/**
 * Build leaderboard from player ranking rows / snapshots.
 *
 * @param {object} input
 * @param {Array<object>} input.playerRows
 * @param {Array<object>} [input.organizationRows]
 * @param {object} [input.filters]
 * @param {{ limit?: number, offset?: number }} [input.page]
 */
export function getLeaderboard(input = {}) {
  const filters = {
    seasonKey: CURRENT_SEASON_KEY,
    ...(input.filters || {}),
  };
  const standings = calculateSeasonStandings(input.playerRows || [], filters);
  const page = paginateItems(standings, input.page || { limit: 25, offset: 0 });
  const orgs = assignOrganizationRanks(input.organizationRows || []);

  return {
    seasonKey: filters.seasonKey,
    filters,
    players: page.items,
    playerPage: page,
    organizations: orgs,
    seasons: listSeasonOptions(
      (input.playerRows || [])
        .map((r) => r.seasonYear)
        .filter((y) => typeof y === "number")
    ),
    generatedAtMs: Date.now(),
  };
}
